<div class="padding" id="div_padding_d4cbe2b1"></div>
<div
  class="wrapper"
  *ngFor="let category of filter.values"
  id="div_wrapper_b0ea017c"
>
  <p-checkbox
    [styleClass]="'trm-filter-checkbox'"
    (onChange)="this.emitContents(category)"
    [value]="category"
    [(ngModel)]="selected"
    checkboxIcon="checkbox-icon"
    id="p-checkbox_3d0ea3ac"
  ></p-checkbox>
  <span
    *ngIf="isNan(category.name); else number"
    class="label"
    id="span_label_42804423"
    >{{ category.name }}</span
  >
  <ng-template #number="" id="ng-template_fb2efc61">
    <span class="label" id="span_label_a3adb11a"
      >{{ category.name | number: '1.0' : 'en-US' }}
      {{ filter['labelTail'] }}</span
    >
  </ng-template>
</div>
